module.exports = "<div><div class=row><div class=col-lg-12><span class=\"pull-left bigger-font\"><strong><l10n>Tickets eligible for changes in</l10n>:</strong></span></div><div class=col-lg-12 ng-repeat=\"item in params.Eligibility track by $index\"><span class=pull-left><span><l10n>{{item.LabelCode}}</l10n></span>: <span><l10n>{{item.LabelValue}}</l10n></span><span class=pl-6>{{item.ComplementaryText}}</span></span></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/atc/templates/atc-check-elegibility-tooltip.html
// module id = 3717
// module chunks = 0